export default "__VITE_ASSET__OK40x53U__"